import { render, staticRenderFns } from "./IconSelector.vue?vue&type=template&id=d1e84586&scoped=true&"
import script from "./IconSelector.vue?vue&type=script&lang=js&"
export * from "./IconSelector.vue?vue&type=script&lang=js&"
import style0 from "./IconSelector.vue?vue&type=style&index=0&id=d1e84586&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e84586",
  null
  
)

export default component.exports